import { LEAD_TYPES } from '@/utils/constants';

export default {
    name: 'ContactMixedPayment',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '800px'
        },
        height: {
            type: String,
            default: 'auto'
        },
        typeConfirmation: {
            type: String,
            default: ''
        },
        textConfirmation: {
            type: String,
            default: ''
        },
        selectedContact: {
            type: Object,
            default: () => {
                return {};
            }
        },
        disableButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            LEAD_TYPES: LEAD_TYPES
        };
    },
    methods: {
        adquireSingleContact(leadsTypes) {
            this.$emit('adquireSingleContact', leadsTypes);
        }
    }
};
